(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home",
                {
                    url: "",
                    component: "home",
                    redirectTo: "Home.Dashboard",
                    resolve: {                                                                                        
                        transactionGroup: [
                            "userApi", function (userApi) {
                                return userApi.getUserTransactionGroup();
                            }
                        ],
                        logo: [
                            "transactionGroup", "transactionGroupApi", function (transactionGroup, transactionGroupApi) {
                                return transactionGroupApi.getLogo(transactionGroup.Id)
                                    .then(function (response) {
                                        return URL.createObjectURL(response);
                                    }, function () { return "Images/icomply-logo-light-bg-tm.svg" });
                            }
                        ],
                        persmissions: ["userApi", "permissionService", function (userApi, permissionService) {
                            if (permissionService.getPermissions() !== null) return null; // no need to re-fetch
                            return userApi.getCurrentUserPermissions().then(function (response) {
                                permissionService.setPermissions(response);
                            });
                        }]
                    }
                });
        }
    ]);

    app.component("home",
        {
            templateUrl: "/App/Home/home.html",
            controller: homeController,
            bindings: {
                transactionGroup: "<",
                logo: "<"                                      
            }
        });

    homeController.$inject = ["$state", "authService", "supportEmailer", "transactionApi"];

    function homeController($state, authService, supportEmailer, transactionApi) {
        var $ctrl = this;
        this.$state = $state;

        $ctrl.logout = function () {
            authService.logout();
        };

        $ctrl.openEmailer = function (event) {
            return supportEmailer.open({
                event: event
                /*template: "Email template",
                title: "ABC Financial Rejection",
                secondaryTitle: "John Smith: Dave Marble - AEL Bonus Gold",
                to: ["brad.westley@figmarketing.com"],
                subject: "test",
                body: "test email"*/
            });
        };
        //$ctrl.$onInit = function () {
        //    var t = "f094479a-156e-4917-b8f5-5d1c114fafa9";
        //    transactionApi.get(t)
        //        .then(function (response) {
        //            transactionApi.updateTransactionAppStatus(t, response);
        //        });
        //};
    }

})(window.app, window.angular);